/**
 * This file serves as a registry for multi-colored icon components.
 * Icons here are rendered as React components instead of using the SVG sprite approach,
 * allowing for multiple colors to be customized.
 *
 * THIS FILE IS AUTO-GENERATED - DO NOT EDIT DIRECTLY
 */

import AlertFilledComponent from './components/alert-filled';
import AlertFilledSmallComponent from './components/alert-filled-small';
import ErrorFilledComponent from './components/error-filled';
import ErrorFilledSmallComponent from './components/error-filled-small';
import HelpFilledComponent from './components/help-filled';
import HelpFilledSmallComponent from './components/help-filled-small';
import InfoFilledComponent from './components/info-filled';
import InfoFilledSmallComponent from './components/info-filled-small';
import SuccessFilledComponent from './components/success-filled';
import SuccessFilledSmallComponent from './components/success-filled-small';
import WeaveUpgradeComponent from './components/weave-upgrade';
import type { IconName } from './icon-constant';

export interface MultiColorIconComponents {
  'alert-filled': typeof AlertFilledComponent;
  'error-filled': typeof ErrorFilledComponent;
  'help-filled': typeof HelpFilledComponent;
  'info-filled': typeof InfoFilledComponent;
  'success-filled': typeof SuccessFilledComponent;
  'alert-filled-small': typeof AlertFilledSmallComponent;
  'error-filled-small': typeof ErrorFilledSmallComponent;
  'help-filled-small': typeof HelpFilledSmallComponent;
  'info-filled-small': typeof InfoFilledSmallComponent;
  'success-filled-small': typeof SuccessFilledSmallComponent;
  'weave-upgrade': typeof WeaveUpgradeComponent;
}

export const multiColorIconComponents: MultiColorIconComponents = {
  'alert-filled': AlertFilledComponent,
  'error-filled': ErrorFilledComponent,
  'help-filled': HelpFilledComponent,
  'info-filled': InfoFilledComponent,
  'success-filled': SuccessFilledComponent,
  'alert-filled-small': AlertFilledSmallComponent,
  'error-filled-small': ErrorFilledSmallComponent,
  'help-filled-small': HelpFilledSmallComponent,
  'info-filled-small': InfoFilledSmallComponent,
  'success-filled-small': SuccessFilledSmallComponent,
  'weave-upgrade': WeaveUpgradeComponent,
};

export const multiColorIconNames = new Set<IconName>([
  'alert-filled',
  'error-filled',
  'help-filled',
  'info-filled',
  'success-filled',
  'alert-filled-small',
  'error-filled-small',
  'help-filled-small',
  'info-filled-small',
  'success-filled-small',
  'weave-upgrade',
]);
